import React from "react";
import { locales } from "../../locales";
import { getDataSource } from "../../services/api";
import CandidateImage from "./CandidateImage";
import { Badge, More } from "../../assets";

const Candidates = ({
  data,
  langId,
  isDesktop,
  onShowTooltip,
  onHideTooltip,
}) => {
  // const titlePadding = (role) => {
  //   if (role) {
  //     return { marginTop: "-4px" };
  //   } else {
  //     return { marginTop: "15px" };
  //   }
  // };

  return (
    <div className="wort-small:grid wort-small:grid-cols-2 wort-small:gap-3 wort-medium:grid-cols-3">
      {data.map((item) => {
        const nationalities = item.nationality
          ? item.nationality.split(",")
          : [];
        const nationalitiesFlags = nationalities.map((item) => {
          if (item.length > 2) {
            return <span className="text-xs">{item}</span>;
          }
          return (
            <img
              src={`${getDataSource()}/flags/${item.toLowerCase()}.svg`}
              alt={item}
              key={item}
              className="w-4 h-4 mr-1 rounded-full"
            />
          );
        });

        return (
          <div
            className="px-2 pt-2.5 flex flex-row items-start rounded-md bg-wort-background h-[155px] mb-3 wort-medium:mb-0"
            // style={boxStyle(isDesktop)}
            key={item.id}
          >
            <CandidateImage
              imageUrl={`${getDataSource()}/portraits/${item.imageWebp}`}
              imageUrlFallback={`${getDataSource()}/portraits/${item.image}`}
            />
            <div className="flex flex-col items-start w-full">
              <div className="flex flex-row justify-between w-full mb-1">
                <span className="font-bold leading-6" style={{ fontSize: 18 }}>
                  {item.name}
                </span>
                {item.function && <Badge />}
              </div>
              <hr style={{ width: "100%" }} />

              <div className="grid grid-cols-1 gap-1 mt-2">
                <div className="flex flex-row">
                  <span className="text-xs mr-2">{locales[langId].age}:</span>
                  <span className="text-xs font-semibold">
                    {item.age ? item.age : locales[langId].noDataAvailable}
                  </span>
                </div>
                <div className="flex flex-row">
                  <span className="text-xs mr-2">
                    {locales[langId].nationality}:{" "}
                    {nationalities.length > 0
                      ? ""
                      : locales[langId].noDataAvailable}
                  </span>

                  {nationalities.length > 0 && nationalitiesFlags}
                </div>
                <div className="flex flex-row">
                  <span className="text-xs mr-2">
                    {locales[langId].firstMandate}:
                  </span>
                  <span className="text-xs font-semibold">
                    {item.firstMandate
                      ? item.firstMandate
                      : locales[langId].noDataAvailable}
                  </span>
                </div>
                <div className="flex flex-row items-center">
                  <span className="text-xs mr-2">
                    {locales[langId].occupation}:
                  </span>
                  <p
                    className="text-xs font-semibold"
                    style={{ lineHeight: "14px" }}
                  >
                    {item.occupation
                      ? item.occupation
                      : locales[langId].noDataAvailable}
                  </p>
                </div>
              </div>
              <div className="flex flex-row justify-end w-full">
                <button
                  onClick={(event) => onShowTooltip(event, item)}
                  onBlur={onHideTooltip}
                  className="focus:outline-none"
                >
                  <More />
                </button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Candidates;
